import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import { Field } from "formik";
import { TextField } from "formik-mui";
import React, { ReactElement } from "react";

import { FieldProps } from "./Field";

export interface InputFieldProps extends FieldProps {
	type?:
		| "button"
		| "text"
		| "number"
		| "email"
		| "hidden"
		| "password"
		| "tel"
		| "url"
		| "date"
		| "checkbox"
		| "search";
	helpText?: string | null | any;
	startAdornment?: ReactElement;
	endAdornment?: ReactElement;
	variant?: string;
}

const InputField = ({
	className,
	name,
	label,
	id,
	helpText,
	fullWidth = true,
	size = "small",
	required,
	startAdornment,
	endAdornment,
	variant = "outlined",
	...others
}: InputFieldProps) => {
	const realId = id || name;
	return (
		<FormControl
			fullWidth={fullWidth}
			variant="standard"
			hiddenLabel
			className={className}
			required={required}
		>
			{label && (
				<InputLabel
					style={{ position: "unset", transform: "none" }}
					disableAnimation
					htmlFor={realId}
					className="mb-1 text-sm font-semibold"
				>
					{label}
				</InputLabel>
			)}
			<Field
				variant={variant}
				id={realId}
				component={TextField}
				name={name}
				InputProps={{
					size,
					startAdornment,
					endAdornment,
					"aria-describedby": `${realId}-helper-text`,
					...others,
				}}
			/>
			{helpText && <FormHelperText id={`${realId}-helper-text`}>{helpText}</FormHelperText>}
		</FormControl>
	);
};

export { InputField };
